import React from "react";

import { Icon } from "../types";

const Circle: React.FC<Icon> = ({ color, width, height, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 8 8" fill={color} {...props}>
    <circle cx="4" cy="4" r="4" fill={color} />
  </svg>
);
export default Circle;
